import { useContext } from 'react'

import ApiErrorHandlerContext from 'Components/ApiErrorHandler/Context'

const useApiErrorHandler = () => useContext(ApiErrorHandlerContext)

export default useApiErrorHandler
